/**
 * Прокрутка слайдеров тачпадом и колесом мыши.
 *
 * Тема листает слайдеры только кнопками: они построены на Swiper, а опция
 * mousewheel там не включена и настройки для неё нет.
 *
 * Почему отдельный файл, а не правка assets/collection-list.js. Тот файл
 * вендорский и перезаписывается при обновлении темы — правка в нём стала бы
 * конфликтом на каждом обновлении, как уже случилось с layout/theme.liquid
 * при переходе на 2.3.0. Здесь же собственный файл, который обновление
 * не трогает, а привязка идёт по классу секции.
 *
 * Как подключить: задать секции в редакторе темы произвольный класс
 * wheel-scroll (поле «Custom class»).
 *
 * Листаем не напрямую через Swiper, а нажатием на штатные кнопки слайдера.
 * Так поведение не зависит от внутреннего устройства чужой библиотеки
 * и переживёт её обновление.
 *
 * Вертикальное колесо намеренно НЕ перехватывается. У слайдера включён
 * бесконечный режим: он никогда не заканчивается, и перехват означал бы,
 * что страницу нельзя прокрутить мимо секции, пока курсор над ней.
 * Поэтому реагируем на горизонтальный жест тачпада и на Shift + колесо —
 * это привычное сочетание для горизонтальной прокрутки.
 */
(function () {
  'use strict';

  var STEP_MS = 350; // пауза между листаниями, иначе один жест пролистывает всё
  var THRESHOLD = 8; // мелкое дрожание тачпада игнорируем

  function attach(section) {
    var next = section.querySelector('.swiper-btn-next');
    var prev = section.querySelector('.swiper-btn-prev');
    if (!next || !prev) return; // слайдер выключен или ещё не собран

    var last = 0;

    section.addEventListener(
      'wheel',
      function (event) {
        var horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (!horizontal && !event.shiftKey) return; // вертикальную прокрутку отдаём странице

        var delta = horizontal ? event.deltaX : event.deltaY;
        if (Math.abs(delta) < THRESHOLD) return;

        event.preventDefault();

        var now = Date.now();
        if (now - last < STEP_MS) return;
        last = now;

        (delta > 0 ? next : prev).click();
      },
      { passive: false }
    );
  }

  function boot() {
    document.querySelectorAll('.wheel-scroll').forEach(attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Пересборка секции в редакторе темы.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.wheel-scroll');
    if (section) attach(section);
  });
})();
